import request from './request'

/**
 * 获取当前用户的菜单列表
 */
export function getUserMenus() {
  return request.get('/system/menus/user')
}

/**
 * 获取当前用户的动态路由
 */
export function getRouters() {
  return request.get('/system/menus/routers')
}

/**
 * 获取菜单树
 * @param {object} query - 查询条件
 * @param {number} [query.userId] - 用户ID
 */
export function getMenuTree(query = {}) {
  return request.get('/system/menus/tree', { params: { query } })
}

/**
 * 获取菜单详情
 * @param {number} id - 菜单ID
 */
export function getMenu(id) {
  return request.get(`/system/menus/${id}`)
}

/**
 * 新增菜单
 * @param {object} data - 菜单信息
 * @param {string} data.name - 菜单名称
 * @param {number} data.type - 菜单类型：0-目录，1-菜单，2-按钮
 * @param {number} [data.parentId] - 父菜单ID
 * @param {string} [data.path] - 路由地址
 * @param {string} [data.component] - 组件路径
 * @param {string} [data.redirect] - 重定向地址
 * @param {string} [data.perms] - 权限标识
 * @param {string} [data.icon] - 菜单图标
 * @param {number} [data.sort] - 排序号
 * @param {number} [data.visible] - 是否显示：0-隐藏，1-显示
 * @param {number} [data.status] - 状态：0-禁用，1-启用
 * @param {number} [data.isCache] - 是否缓存：0-否，1-是
 * @param {number} [data.isFrame] - 是否外链：0-否，1-是
 */
export function createMenu(data) {
  return request.post('/system/menus', data)
}

/**
 * 修改菜单
 * @param {number} id - 菜单ID
 * @param {object} data - 菜单信息
 */
export function updateMenu(id, data) {
  return request.put(`/system/menus/${id}`, data)
}

/**
 * 删除菜单
 * @param {number} id - 菜单ID
 */
export function deleteMenu(id) {
  return request.post(`/system/menus/${id}/delete`)
}

/**
 * 获取角色菜单ID列表
 * @param {number} roleId - 角色ID
 */
export function getRoleMenuIds(roleId) {
  return request.get(`/system/menus/role/${roleId}`)
}

/**
 * 为角色分配菜单
 * @param {number} roleId - 角色ID
 * @param {object} data - 菜单分配信息
 * @param {number} data.roleId - 角色ID
 * @param {number[]} data.menuIds - 菜单ID列表
 */
export function grantMenusToRole(roleId, data) {
  return request.post(`/system/menus/role/${roleId}`, data)
}
